import { Button } from "antd";
import React from "react";
import { BUTTON_CONSTANTS } from "./ManageSchedulers";
import { Link } from "react-router-dom";

// assets images
import SwitchIcon from "../../../assets/switch-icon-2.png";
import TrasnferOwnershipIcon from "../../../assets/transfer-ownership-icon-black-2.png";
import EditIcon from "../../../assets/edit-icon-3.png";
import { useBoundStore } from "../../../store/useBoundStore";
import ActionButtonDropdown from "./ActionButtonDropdown";
import { Translate } from "react-translated";
import TransferOwnership from "../../../assets/transfer_ownership.svg"
import { removeHeaderTitle, REVIEWSCHEDULER } from "../../../utils/Constants";


const ActionButtonRenderer = (props) => {
  const { RSFSFilters, setRSFSCardFilters, resetRSFSFilters } = useBoundStore();
  const { userType } = useBoundStore((state) => ({
    userType: state.userType,
  }));

  const { data, onButtonClick, currentState } = props;
  // console.log("props manage schedulers", data);
  const roles =
    data &&
    data.type_of_Call &&
    data.type_of_Call.split(",").map((item) => item.trim());


  const hasReviewRole = roles.includes("Review");
  const hasLeadRole = roles.includes("Lead");
  const hasOpportunityRole = roles.includes("Opportunity");

  // Show Transfer Agency if only Review is present
  const shouldShowTransferAgency =
    hasReviewRole && !hasLeadRole && !hasOpportunityRole;

  // Show Unlink B Files if Lead or Opportunity is present
  const shouldShowUnlinkBFile = hasLeadRole || hasOpportunityRole;

  // Show both Transfer Agency and Unlink B Files if Review is with Lead or Opportunity
  const shouldShowBothButtons =
    false;

  const handleButtonClick = (buttonType) => {
    if (buttonType === "transfer_ownership") {
      onButtonClick(buttonType, data);
    } else if (buttonType === "switch_to_scheduler") {
      onButtonClick(buttonType, data);
    } else if (buttonType === "switch_to_REVIEWSCHEDULER") {
      onButtonClick(buttonType, data);
    } else if (buttonType === "switch_to_VONBOARDER") {
      onButtonClick(buttonType, data);
    } else if (buttonType === "switch_to_VONSCHEDULER") {
      onButtonClick(buttonType, data);
    } else if (buttonType === "unlink_user") {
      onButtonClick(buttonType, data);
    } else if (buttonType === BUTTON_CONSTANTS.deActivated.key) {
      onButtonClick(buttonType, data);
    } else if (buttonType === BUTTON_CONSTANTS.agencies.key) {
      onButtonClick(buttonType, data);
    }
  };

  // console.log("currentState ==>", currentState);
  return (
    <div style={{ display: "flex", gap: "6px" }}>
      {/* Edit user button */}
      <Link
        to={"/manage-users/edit-user/" + data.user.id + "?edit_user_type=scheduler"}
        style={{ display: "flex", marginTop: "7px", }}
      >
        <Button
          style={{ width: "100%" }}
          className="borderRadius-28"
          // className="manageScheduler-table-btn"
          onClick={() => handleButtonClick(BUTTON_CONSTANTS.edit_user.key)}
        >
          <img src={EditIcon} alt="Edit Icon" />
          &nbsp;
          {BUTTON_CONSTANTS.edit_user.label}
        </Button>
      </Link>

      {/* Show Transfer Agency if only Review is present */}
      {shouldShowTransferAgency && (
        <div style={{ width: "200px" }}>
          <Button
            className="manageScheduler-table-btn borderRadius-28"
            style={{ marginTop: "7px" }}
            type="default"
            disabled={false}
            onClick={() =>
              handleButtonClick(BUTTON_CONSTANTS.transfer_ownership.key)
            }
          >
            <img src={TransferOwnership} alt="Switch Icon" />
            &nbsp;
            Transfer Ownership
          </Button>
        </div>
      )}

      {/* Show Unlink B Files if only Lead or Opportunity is present */}
      {shouldShowUnlinkBFile && !shouldShowBothButtons && (
        <Button
          className="manageScheduler-table-btn borderRadius-28"
          style={{ marginTop: "7px" }}
          type="default"
          disabled={false}
          onClick={(e) => {
            handleButtonClick(BUTTON_CONSTANTS.unlink_user.key);
          }}
        >
          <img src={TransferOwnership} alt="Switch Icon" />
          &nbsp;
          {/* {BUTTON_CONSTANTS.unlink_user.label} */}
          Transfer Ownership

        </Button>
      )}

      {/* Show both buttons if Review is with Lead or Opportunity */}
      {shouldShowBothButtons && (
        <ActionButtonDropdown
          user_type={data.user_type}
          handleButtonClick={handleButtonClick}
        />
      )}


      <div style={{ width: "200px" }}>
        <Button
          style={{ marginTop: "7px", width: "200px" }}
          className="manageScheduler-table-btn borderRadius-28"
          type="default"
          onClick={(e) => {
            setRSFSCardFilters({
              defaultToggleUserRole: REVIEWSCHEDULER,
              selectedToggle: REVIEWSCHEDULER,
              selectedToggleAPI: REVIEWSCHEDULER
            });
            localStorage.removeItem('card');
            localStorage.removeItem('callCount');
            localStorage.removeItem('buckets');
            removeHeaderTitle()
            handleButtonClick(BUTTON_CONSTANTS.switch_to_VONSCHEDULER.key);
          }
          }
        >
          <img src={SwitchIcon} alt="Switch Icon" />
          &nbsp;
          {BUTTON_CONSTANTS.switch_to_VONSCHEDULER.label}
        </Button>
      </div>
      {/* ) : null} */}

      <Button
        className="my-btn-width borderRadius-28"
        // style={{ marginLeft: 10 }}
        style={{ marginTop: "7px" }}
        onClick={() => handleButtonClick(BUTTON_CONSTANTS.deActivated.key)}
      >
        <img src={TransferOwnership} alt="Switch Icon" />
        &nbsp;
        <Translate text={`${BUTTON_CONSTANTS.deActivated.label}`} />
      </Button>

      {data && (
        <Button
          className="my-btn-width borderRadius-28"
          // style={{ marginLeft: 5 }}
          style={{ marginTop: "7px" }}

          onClick={() => handleButtonClick(BUTTON_CONSTANTS.agencies.key)}
        >
          <img src={EditIcon} alt="Edit Icon" />
          &nbsp;
          <Translate text={`${BUTTON_CONSTANTS.agencies.label}`} />
        </Button>
      )}
      {/* </span> */}
    </div>
  );
};

export default ActionButtonRenderer;



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/ManageSchedulers/ActionButtonRenderer.js